import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { Form, Formik } from "formik";
import FormikCheckbox from "components/form/formik-checkbox";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";

export default function UserRolesDialog({
    showUserRoleDialog,
    setShowUserRoleDialog,
    handleUserSubmit,
    userData,
    rolesList,
}) {
    const handleClose = () => {
        setShowUserRoleDialog((showUserRoleDialog) => !showUserRoleDialog);
    };
    return (
        <Dialog
            open={showUserRoleDialog}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">
                Manage User Roles
            </DialogHeader>
            <Formik
                initialValues={{
                    roles: userData?.roles || {},
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    await handleUserSubmit(values);
                    setSubmitting(false);
                    handleClose();
                }}
                enableReinitialize
            >
                {({ isValid, dirty, values, setFieldValue }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <Typography className="px-4 pt-2 font-body">
                                Assign roles to this user by selecting the checkboxes below.
                            </Typography>
                            {!!rolesList && (
                                <>
                                    <div className=" bg-white rounded-xl p-2 mt-4">
                                        <GobbyTable>
                                            <GobbyTableHead>
                                                <GobbyTableRow>
                                                    <GobbyTableHeader className="w-5/6 pl-1 pt-4">
                                                        Role
                                                    </GobbyTableHeader>
                                                    <GobbyTableHeader className="w-1/6 pt-4">
                                                        Assign
                                                    </GobbyTableHeader>
                                                </GobbyTableRow>
                                            </GobbyTableHead>
                                            <GobbyTableBody>
                                                {rolesList?.map(
                                                    (role, index) => (
                                                        <GobbyTableRow
                                                            key={role.id}
                                                        >
                                                            <GobbyTableCell className="">
                                                                {role.name}
                                                            </GobbyTableCell>
                                                            <GobbyTableCell className="text-right md:pr-4">
                                                                <FormikCheckbox
                                                                    name="roles"
                                                                    type="checkbox"
                                                                    value={
                                                                        role.id
                                                                    }
                                                                    checked={
                                                                        values
                                                                            .roles?.[
                                                                                `${role.id}`
                                                                            ]
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        if (
                                                                            e
                                                                                .target
                                                                                .checked
                                                                        ) {
                                                                            setFieldValue(
                                                                                `roles[${role.id}]`,
                                                                                role.name,
                                                                            );
                                                                        } else {
                                                                            setFieldValue(
                                                                                `roles.[${role.id}]`,
                                                                                undefined,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            </GobbyTableCell>
                                                        </GobbyTableRow>
                                                    ),
                                                )}
                                            </GobbyTableBody>
                                        </GobbyTable>
                                    </div>
                                </>
                            )}
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <div className="gap-2">
                                <Button
                                    type="button"
                                    className="btn btn--secondary"
                                    variant="filled"
                                    size="lg"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={!(isValid && dirty)}
                                    className="btn btn--primary"
                                    variant="filled"
                                    size="lg"
                                >
                                    Save
                                </Button>
                            </div>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
